import {
  OPERATORS_LOGO,
  OPERATORS_TOPUP_AMOUNT_TYPE,
  OPERATORS_TOPUP_AMOUNTS,
  OPERATORS_TOPUP_VALUE, PRODUCTS_CODES
} from '@/common/const/operators.const'

const OPERATOR_LOGO_PATH = '/images/doladuj-tutaj/logo/'

export default {
  methods: {
    getOperatorLogoSrc (operator, amount) {
      let path = `${OPERATOR_LOGO_PATH}${OPERATORS_LOGO[operator]}`
      if (operator === PRODUCTS_CODES.player && amount) {
        path = path.replace('.svg', '-' + amount + '.png')
      }
      return path
    },
    getOperatorValue (operator) {
      return OPERATORS_TOPUP_VALUE[operator]
    },
    isOperatorTopupAmountTypeAny (operator) {
      return OPERATORS_TOPUP_AMOUNTS[operator].type === OPERATORS_TOPUP_AMOUNT_TYPE.any
    },
    isOperatorTopupAmountTypeList (operator) {
      return OPERATORS_TOPUP_AMOUNTS[operator].type === OPERATORS_TOPUP_AMOUNT_TYPE.list
    },
    getOperatorTopupAmountList (operator) {
      return OPERATORS_TOPUP_AMOUNTS[operator].values
    },
    getOperatorTopupAmountMin (operator) {
      return OPERATORS_TOPUP_AMOUNTS[operator].min
    },
    getOperatorTopupAmountMax (operator) {
      return OPERATORS_TOPUP_AMOUNTS[operator].max
    }
  }
}
